module.exports = __webpack_public_path__ + "img/04db92922a72940f74b3f777ac1bd18a.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo5.png
// module id = 913
// module chunks = 5